'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeIcon = exports.CloseIcon = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 20px;\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 24px;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  user-select: none;\n  flex-shrink: 0;\n'], ['\n  font-size: 20px;\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 24px;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  user-select: none;\n  flex-shrink: 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  opacity: 0.9;\n  margin-right: 8px;\n  font-size: 20px;\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 24px;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  user-select: none;\n  flex-shrink: 0;\n'], ['\n  opacity: 0.9;\n  margin-right: 8px;\n  font-size: 20px;\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  font-size: 24px;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  user-select: none;\n  flex-shrink: 0;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Close = _styledComponents2.default.svg(_templateObject);
var Icon = _styledComponents2.default.svg(_templateObject2);
var CloseIcon = exports.CloseIcon = function CloseIcon() {
  return _react2.default.createElement(
    Close,
    { focusable: 'false', viewBox: '0 0 24 24', 'aria-hidden': 'true', role: 'presentation' },
    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' }),
    _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' })
  );
};

var SuccesIcon = function SuccesIcon() {
  return _react2.default.createElement(
    Icon,
    { focusable: 'false', viewBox: '0 0 24 24', 'aria-hidden': 'true', role: 'presentation' },
    _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' }),
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
  );
};

var ErrorIcon = function ErrorIcon() {
  return _react2.default.createElement(
    Icon,
    { focusable: 'false', viewBox: '0 0 24 24', 'aria-hidden': 'true', role: 'presentation' },
    _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' }),
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
  );
};

var WaringIcon = function WaringIcon() {
  return _react2.default.createElement(
    Icon,
    { focusable: 'false', viewBox: '0 0 24 24', 'aria-hidden': 'true', role: 'presentation' },
    _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' }),
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};

var InfoIcon = function InfoIcon() {
  return _react2.default.createElement(
    Icon,
    { focusable: 'false', viewBox: '0 0 24 24', 'aria-hidden': 'true', role: 'presentation' },
    _react2.default.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z' }),
    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
  );
};

var TypeIcon = exports.TypeIcon = function TypeIcon(_ref) {
  var type = _ref.type;

  switch (type) {
    case 'success':
      return SuccesIcon();
    case 'error':
      return ErrorIcon();
    case 'warning':
      return WaringIcon();
    case 'info':
      return InfoIcon();
    default:
      return SuccesIcon();
  }
};